import React from 'react';
import './CustomTimeline.css';

const Timeline = ({ children, className = '' }) => {
  return (
    <div className={`custom-timeline ${className}`}>
      {children}
    </div>
  );
};

const TimelineItem = ({ dot, children }) => {
  return (
    <div className="timeline-item">
      <div className="timeline-marker">
        {dot || <div className="timeline-dot"></div>}
      </div>
      <div className="timeline-content">
        {children}
      </div>
    </div>
  );
};

Timeline.Item = TimelineItem;

export { Timeline };
export default Timeline;



// WEBPACK FOOTER //
// ./src/components/chat/components/CustomTimeline.js